import React from "react";
import { useTranslation } from "react-i18next";
import style from "../partnerProfileModal.module.scss";
import EyeIcon from "../../../../shared/icons/EyeIcon";
import Loading from "../../../../shared/Loading/Loading";
import AppTooltip from "../../../../shared/AppTooltip/AppTooltip";

const DocumentItem = ({ doc, partnerId, isLoading, onView }) => {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ru-RU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getDocumentTitle = (type) => {
    switch (type) {
      case 0:
        return t("documents.registrationCertificate");
      case 2:
        return t("documents.appointmentOrder");
      default:
        return t("documents.doc");
    }
  };

  return (
    <div className={style.documentItem}>
      <div className={style.documentItem_content}>
        <div className={style.documentHeader}>
          <h4>{getDocumentTitle(doc?.type)}</h4>
        </div>
        <div className={style.documentDate}>{formatDate(doc.createdAt)}</div>
      </div>
      {isLoading ? (
        <Loading inBlock marginBottom={0} />
      ) : (
        <>
          <EyeIcon
            onClick={() => onView(doc?.type, partnerId)}
            style={{ cursor: "pointer" }}
            data-tooltip-id="doc-item-eye-tooltip"
          />
          <AppTooltip id="doc-item-eye-tooltip" place="top" positionStrategy="fixed">
            {t('tooltips.showOrDownload')}
          </AppTooltip>
        </>
      )}
    </div>
  );
};

export default DocumentItem;
